import useGetUser from './useGetUser';

const useIsStaff = () => {
  const currentUser = useGetUser();

  return Boolean(currentUser?.isStaff);
};

export default useIsStaff;
